import { Editor, Transforms } from 'slate';

import { ELEMENT_PARAGRAPH, ELEMENT_UL, isSelectionExpanded } from '../../../../../slatePlugins';
import { getNodes } from '../../../../../slatePlugins/common/queries/getNodes';
import { unwrapNodes } from '../../../../../slatePlugins/transforms/unwrapNodes';
import { isInsideOfElement } from '../../../helpers/selection';
import { wrapBlockAtSelection } from '../../../helpers/toggleBlockAtSelection';
import { ELEMENT_BORDER_SHADING } from '../defaults';

const ELEMENT_QUOTE = 'blog-blockquote';

const isBorderShadingActive = (editor) => isInsideOfElement(editor, ELEMENT_BORDER_SHADING);

export const unwrapBorderShading = (editor, options?) =>
  unwrapNodes(editor, { match: { type: ELEMENT_BORDER_SHADING }, ...options });

export const wrapBorderShading = (editor, options?) => {
  // Check if in border and shading block, unwrap current block
  if (isBorderShadingActive(editor)) {
    unwrapBorderShading(editor);
  }

  // Add border and shading
  wrapBlockAtSelection(editor, ELEMENT_BORDER_SHADING, {}, { mode: 'highest', ...options });
  Transforms.collapse(editor, { edge: 'end' });
};

export const addBorderShading = (editor) => {
  // Only add when selection expanded
  if (editor.selection && isSelectionExpanded(editor)) {
    // Get start and end nodes
    const {
      length: l,
      0: firstNode,
      [l - 1]: lastNode,
    } = Array.from(
      getNodes(editor, {
        at: editor.selection,
        match: (node: any) => {
          // Why need to have if case here => to check other tag before p tag because p tag is child of other tag.
          if ([ELEMENT_UL, ELEMENT_QUOTE].includes(node.type as string)) {
            return true;
          }
          return ELEMENT_PARAGRAPH === node.type;
        },
        mode: 'highest', // Need to enable mode: 'highest' to get level 1 block only
      }),
      ([node, path]) => ({
        node,
        path,
      })
    );

    wrapBorderShading(editor, {
      at: Editor.range(editor, firstNode.path, lastNode.path),
    });
  }
};
